import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

export function useDashboardStats() {
  return useQuery({
    queryKey: queryKeys.dashboard.stats(),
    queryFn: () => dashboardApi.getStats(),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
